<template>
  <div>
    <DialogBottomSheet
      :is-visible="isDialogOpened"
      :width="isMobile ? undefined : 375"
      content-class="rounded-0"
      @input="filtersStore.resetUnsavedFilters"
      @dialog-bottom-sheet:change-visible="closeDialog"
    >
      <v-card
        tile
        class="pt-6 px-4 pb-4"
      >
        <ChipGroupGender
          v-model="filtersStore.unsavedFilters"
          class="mb-2"
        >
          <template #title>
            <div class="text-h6 mb-2">
              {{ t('Пол врача', options) }}
            </div>
          </template>
        </ChipGroupGender>
        <BtnShowDoctors
          :active="isDialogOpened"
          @click:close="closeDialog"
          @click:submit="applyFilter"
        />
      </v-card>
    </DialogBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import ChipGroupGender from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupGender/ChipGroupGender.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('GenderFilters')
const isMobile = window.MOBILE_VERSION

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

watch(
  () => filtersStore.filters.gender,
  () => {
    if (!filtersStore.filters.gender) {
      chipsStore.updateGenderChip({ isVisible: false })
      return
    }

    const name = ({
      F: t('Женщина', options.value),
      M: t('Мужчина', options.value),
    })[filtersStore.filters.gender]

    chipsStore.updateGenderChip({
      name,
      isActive: true,
      isVisible: true,
      onClick: openDialog,
      async onReset() {
        filtersStore.updateFilters({ gender: undefined })

        await updateDoctorListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

const applyFilter = async () => {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  await updateDoctorListPage()
}
</script>
